import React from 'react';
import {useStoreState} from 'easy-peasy';
import {useSearchParams, useParams} from 'react-router-dom';
import StoryboardViewContainer from '@/views/storyboard/StoryboardViewContainer';
import useData from '@/utils/useData';
import CellLoader from '@/components/loading/CellLoader';
import {Story} from '@/entities/story';

interface AgentDashboardViewProps {
    agentId?: string;
}

const AgentDashboardView: React.FC<AgentDashboardViewProps> = React.memo(({agentId}) => {
    const urlParams = useParams();
    const [searchParams] = useSearchParams();
    const activeStoryObject = useStoreState((state: any) => state.activeStoryObject.activeStoryObject);
    const agentIdToUse = agentId || (urlParams as any).agentId;
    
    const [personsStories, loadingPersonsStories] = useData<Story[]>(window.URLS.storiesResource, {
        storeResolver: 'personsStories',
        initialValue: [],
        requestParams: {
            params: {storyListType: 'personsStories'},
        },
    });

    if (loadingPersonsStories) {
        return <CellLoader fullHeight={true} />;
    }

    const story = personsStories.find((s: Story) => s.assignedUrl === 'agents');
    if (!story) {
        return <div>Dashboard not found for agents</div>;
    }

    const storyboardParam = searchParams.get('storyboard');
    const slugParam = searchParams.get('slug');
    const activeStoryboardHashid = storyboardParam || story.firstStoryboardHashid;
    const activeStoryboardUrl = slugParam || story.firstStoryboardSlug;
    const activeStoryObjectResolved = agentIdToUse || activeStoryObject;

    return (
        <>
            <StoryboardViewContainer
                key={`${activeStoryboardHashid}-${activeStoryboardUrl}-${activeStoryObjectResolved}`}
                activeStoryboardHashid={activeStoryboardHashid}
                activeStoryUrl="agents"
                activeStoryboardUrl={activeStoryboardUrl}
                activeStoryObject={activeStoryObjectResolved}
                hideNavigation={false}
            />
        </>
    );
});

export default AgentDashboardView;
